import { DosageLevelModel } from "./dosageLevelModel";
import { DosageContentContentModel } from './dosageContentContentModel';

export class DosageContentModel {
  public dosageContentId: number;
  public medicineId: number;
  public summary: string;
  public overdoseDescription: string;
  public professionalDescription: string;
  public doseAdjustments: string;
  public precautions: string;
  public otherComments: string;
  public otherInformation: string;
  public dosageLevels: Array<DosageLevelModel>;
  public dosageContentContent: Array<DosageContentContentModel>;
}